import { BoxProps, Flex, Text } from "@chakra-ui/react";

export function SlimTag({
  text,
  ...props
}: BoxProps & { text: string | JSX.Element }) {
  return (
    <Flex
      {...props}
      as="button"
      padding="2px 8px"
      gap="8px"
      borderRadius="4px"
      border="1px solid"
      borderColor="transparent.white.10"
      background="transparent.dune.10"
      justifyContent="center"
      transition="linear 0.1s all"
      _hover={{
        background: "transparent.dune.20",
      }}
    >
      {typeof text === "string" ? (
        <Text
          fontSize="12px"
          color="charcoal.100"
          fontWeight="500"
          letterSpacing=".5px"
        >
          {text}
        </Text>
      ) : (
        text
      )}
    </Flex>
  );
}
